(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("ReportsDepartmentsController", ReportsDepartmentsController);

    function ReportsDepartmentsController($scope, config, logger, $q, $translate, uiGridConstants, cgbusyService, reportService, jsReportService, modalDialogService, dataService) {
        var vm = this;

        vm.settings = config.settings;

        vm.gridOptions = {
            enableFiltering: true,
            enableSorting: false,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: '',
                    name: 'drilldown',
                    width: 40,
                    enableColumnMenu: false,
                    enableFiltering: false,
                    cellTemplate: '<button class="btn btn-default btn-xs" ng-if="row.entity.hasChildDepartments" ng-click="grid.appScope.drilldown(row.entity)"><i class="glyphicon glyphicon-chevron-right"/></button>'
                },
                {
                    displayName: $translate.instant('department'),
                    name: 'departmentName',
                    enableColumnMenu: false,
                    enableSorting: true,
                    sort: {
                        direction: uiGridConstants.ASC,
                        priority: 0
                    },
                    sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
                },
                {
                    displayName: $translate.instant('approved'),
                    name: 'numberApproved',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    width: 150
                },
                {
                    displayName: $translate.instant('total'),
                    name: 'numberTotal',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    width: 150
                },
                {
                    displayName: $translate.instant('percentage'),
                    field: 'percentage',
                    cellTemplate: '/app/templates/common/report-progress-cell.tpl.html',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    exporterSuppressExport: true,
                    width: 100
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/common/show-details-cell.tpl.html',
                    enableColumnMenu: false,
                    enableFiltering: false,
                    width: 40
                }
            ]
        };

        vm.params = {};
        vm.parents = [];
        vm.filter = {};

        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;
        vm.drilldown = drilldown;
        vm.drillup = drillup;
        vm.removeFilter = removeFilter;
        vm.showDetails = showDetails;
        vm.showDetailsVisible = showDetailsVisible;

        $scope.$watch("vm.parents", () => {
            vm.gridOptions.gridApi.grid.clearAllFilters();
            vm.params.parentDepartmentId = vm.parents.length === 0 ? null : vm.parents[vm.parents.length - 1].id;
        }, true);

        $scope.$watch("vm.params", () => { _loadData(); }, true);

        $scope.$watch("vm.selectedFilter", (n) => {
            if (!n) return;
            
            var filter = angular.copy(vm.selectedFilter);

            vm.selectedFilter = null;

            if (vm.filter.id !== filter.id) vm.filter = filter;
        });
        
        $scope.$watch("vm.filter", (n, o) => {
            if (n === o) return;
            
            var params = {
                parentDepartmentId: vm.parentDepartmentId,
                clusterId: null,
                actionId: null
            };

            if (vm.filter.type === 'cluster') {
                params.clusterId = vm.filter.id;
            } else {
                params.actionId = vm.filter.id;
            }

            vm.params = params;
        });

        function _downloadReport(type) {
            var reportInfo = {
                filterType: vm.filter.type || null,
                filterName: vm.filter.name || null
            };

            var items = vm.gridOptions.gridApi.core.getVisibleRows().map(function (item) { return item.entity; });

            return jsReportService.getDepartmentsReport(type, reportInfo, items);
        }

        function _loadData() {
            vm.gridOptions.data = [];

            cgbusyService.blockUI(
                reportService.getDepartmentReport(vm.params).then(data => {
                    vm.gridOptions.data = data;
                    vm.gridOptions.gridApi.core.handleWindowResize();
                })
            );
        }

        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }
        
        function drilldown(entity) {
            vm.parents.push({ id: entity.departmentId, name: entity.departmentName });
        }

        function drillup(departmentId) {
            var parent = vm.parents.find(x => x.id === departmentId);
            vm.parents.splice(vm.parents.indexOf(parent) + 1);
        }

        function removeFilter() {
            vm.filter = {};
        }

        function showDetails(entity) {
            var params = {
                type: 'department',
                departmentId: entity.departmentId,
                actionId: vm.params.actionId,
                clusterId: vm.params.clusterId
            };
            
            return dataService
                .getUserQualitiesForReport(params)
                .then(data => {
                    params.data = data;
                    params.title = entity.departmentName;
                    modalDialogService.openReportDetailsDialog(params);
                });
        }

        function showDetailsVisible(entity) {
            if (entity.numberDirectly === 0) return false; // no direct users, never show
            if (vm.settings.user.isAdmin) return true; // user is admin and admins can view user info
            if (vm.settings.user.isManager && vm.settings.user.departmentIdsWhereManager.indexOf(entity.departmentId) > -1) return true; // direct manager of this department
            if (vm.settings.user.isReportViewer && vm.settings.reportViewerSettings.anonymizeReports === false) return true; // reportviewers can view user info
            return false;
        }
    }

})();